var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C12.9375 0 11.25 1.6875 11.25 3.75V56.25C11.25 58.3125 12.9375 60 15 60H52.5C54.5625 60 56.25 58.3125 56.25 56.25V15L41.25 0H15Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 15H56.25L41.25 0V11.25C41.25 13.3125 42.9375 15 45 15Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.25 26.25L45 15H56.25V26.25Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 48.75C48.75 49.7812 47.9062 50.625 46.875 50.625H5.625C4.59375 50.625 3.75 49.7812 3.75 48.75V30C3.75 28.9688 4.59375 28.125 5.625 28.125H46.875C47.9062 28.125 48.75 28.9688 48.75 30V48.75Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2276 45.0021C13.7476 44.7302 13.4476 44.1921 13.7476 43.5621L18.0507 35.1527C18.4557 34.3577 19.5338 34.3277 19.9088 35.1527L24.1369 43.5621C24.7519 44.7302 22.9369 45.6602 22.3969 44.4902L21.7369 43.1721H16.2057L15.5626 44.4921C15.3226 45.0021 14.7676 45.1071 14.2276 45.0021ZM20.6738 41.194L18.9788 37.4908L17.1357 41.194H20.6738Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3127 44.327L24.3545 36.0376C23.7695 34.8526 25.5395 33.8795 26.1977 35.1226L27.5327 38.1358L29.2558 42.092L30.9489 38.1358L32.2839 35.1226C32.8839 33.9845 34.6221 34.7026 34.1139 35.9476L30.2908 44.327C29.9458 45.272 28.8808 45.497 28.3127 44.327Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9624 35.5259C35.9624 34.2978 37.9424 34.2509 37.9424 35.5259V44.0853C37.9424 45.3303 35.9624 45.3603 35.9624 44.0853V35.5259Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.875 50.625H11.25V52.5H46.875C47.9062 52.5 48.75 51.6562 48.75 50.625V48.75C48.75 49.7812 47.9062 50.625 46.875 50.625Z",
    fill: "#CAD1D8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvi);
export default __webpack_public_path__ + "static/media/avi.2666428231e979063dd4dc3863998d47.svg";
export { ForwardRef as ReactComponent };